<template>
  <div class="card p-shadow-app">
    <h1>Famílias de Produtos</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>
    <div style="height: 75vh">
      <DataTable
        :value="list"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        stripedRows
        sortMode="single"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :lazy="true"
        :totalRecords="totalRecords"
        @filter="loadProductFamilies"
        @sort="loadProductFamilies"
        @page="loadProductFamilies"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
      >
        <template #empty> Nada a mostrar. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <template #header>
          <div class="table-header">
            <Button
              icon="pi pi-plus"
              @click="addNew"
              v-if="can('createUpdateParts')"
            />
          </div>
        </template>
        <Column
          field="name"
          filterField="name"
          header="Nome da Família"
          sortable
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              v-tooltip="'Alterar Nome da Família'"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.name ?? "_______" }}
            </span>
            <span v-else>{{ slotProps.data.name ?? "" }}</span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
            />
          </template>
        </Column>
        <Column
          field="products_count"
          header="Nº de Produtos"
          sortable
          style="min-width: 8rem; text-align: center"
          headerStyle="text-align: center"
        >
          <template #body="slotProps">
            {{ slotProps.data.products_count ?? 0 }}
          </template>
        </Column>
        <Column
          field="origin"
          filterField="origin"
          header="Origem"
          sortable
        >
          <template #body="slotProps">
            {{ slotProps.data.origin ?? "" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: 'LG', label: 'LG' },
                { value: 'HISENSE', label: 'HISENSE' },
                { value: 'SAMSUNG', label: 'SAMSUNG' },
              ]"
              optionValue="value"
              optionLabel="label"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column
          field="phc_family_ref"
          filterField="phc_family_ref"
          header="Ref. Família PHC"
          sortable
        >
          <template #body="slotProps">
            {{ slotProps.data.phc_family_ref ?? "" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
            />
          </template>
        </Column>
        <Column
          field="sales_margin"
          header="Margem (%)"
          sortable
          filterField="sales_margin"
        >
          <template #body="slotProps">
            {{ slotProps.data.sales_margin !== null && slotProps.data.sales_margin !== undefined ? slotProps.data.sales_margin + '%' : '-' }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
            />
          </template>
        </Column>
        <Column
          field="weight"
          header="Peso (Kg)"
          sortable
          filterField="weight"
        >
          <template #body="slotProps">
            {{ slotProps.data.weight !== null && slotProps.data.weight !== undefined ? slotProps.data.weight + ' kg' : '-' }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
            />
          </template>
        </Column>
        <Column field="is_default" header="Predefinido" sortable filterField="is_default">
          <template #body="slotProps">
            {{ slotProps.data.is_default == 1 ? "Sim" : "Não" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: 0, label: 'Não' },
                { value: 1, label: 'Sim' },
              ]"
              optionValue="value"
              optionLabel="label"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column field="active" header="Activa" sortable filterField="active">
          <template #body="slotProps">
            {{ slotProps.data.active == 1 ? "Sim" : "Não" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: 0, label: 'Não' },
                { value: 1, label: 'Sim' },
              ]"
              optionValue="value"
              optionLabel="label"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      :visible.sync="form.show"
      :containerStyle="{ width: $isMobile() ? '100vw' : '40vw' }"
      :maximizable="true"
      :modal="true"
      v-on:hide="hideForm"
      v-on:show="
        () => {
          $validator.resume();
        }
      "
      :header="
        form.id ? 'Editar Família de Produtos' : 'Nova Família de Produtos'
      "
    >
      <form class="p-col-12" @submit.prevent="save">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-10">
            <span class="p-float-label">
              <InputText
                :id="'name'"
                :name="'name'"
                autocomplete="off"
                v-validate="'required'"
                v-model="form.name"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('name'),
                  },
                  'form-control',
                ]"
              />
              <label for="name">Nome da Família de Produtos</label>
            </span>
            <small v-if="errors.has('name')" class="p-error" role="alert">
              Nome da Família de Produtos é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-2 p-mt-2">
            <span
              class="p-float-label"
              style="top: -0.75rem; left: -1rem; font-size: 12px"
            >
              <label for="active">Ativo</label>
            </span>
            <InputSwitch
              v-model="form.active"
              :name="'active'"
              :id="'active'"
              style="'top: 4px;"
            />
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                v-model="form.origin"
                :options="['LG', 'HISENSE', 'SAMSUNG']"
                :showClear="true"
                id="origin"
                name="origin"
                :appendTo="'body'"
              />
              <label for="origin">Origem</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <InputText
                v-model="form.phc_family_ref"
                autocomplete="off"
                id="phc_family_ref"
                name="phc_family_ref"
              />
              <label for="phc_family_ref">Ref. Família PHC</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                v-model="form.sales_margin"
                id="sales_margin"
                name="sales_margin"
                mode="decimal"
                :min="0"
                :max="100"
                :minFractionDigits="0"
                :maxFractionDigits="2"
                suffix="%"
              />
              <label for="sales_margin">Margem Venda (%)</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                id="weight"
                name="weight"
                mode="decimal"
                :min="0"
                :minFractionDigits="3"
                :maxFractionDigits="3"
                :useGrouping="false"
                locale="pt-PT"
                v-model="form.weight"
              />
              <label for="weight">Peso (kg)</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4 p-mt-3">
            <span
              class="p-float-label"
              style="top: -0.75rem; left: -1rem; font-size: 12px"
            >
              <label for="is_default">Predefinido (Importador)</label>
            </span>
            <InputSwitch
              v-model="form.is_default"
              :name="'is_default'"
              :id="'is_default'"
              style="'top: 4px;"
            />
          </div>
          <div class="p-field p-col-12 p-mt-4">
            <label style="font-weight: 600; display: block; margin-bottom: 6px;">Imagem da Família</label>
            <div v-if="form.images && form.images.length > 0" class="p-d-flex p-flex-wrap p-ai-center p-jc-start">
              <AuthenticatedImage
                :file="form.images[0]"
                fileServiceMethod="getSparsFamilyFile"
                alt="Imagem da Família"
                height="100"
                class="p-mr-3"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-sm p-button-danger"
                @click="removeFamilyImage"
                type="button"
                v-tooltip="'Remover Imagem'"
                style="width: auto;"
              />
            </div>
            <div v-else>
              <FileUpload
                ref="familyImage"
                name="familyImage[]"
                accept="image/gif,image/jpg,image/jpeg,image/pjpeg,image/png,image/x-png"
                invalidFileTypeMessage="Ficheiro inválido. Apenas aceita GIF, JPG, JPEG ou PNG"
                :previewWidth="100"
                :multiple="false"
                :fileLimit="1"
                :showUploadButton="false"
                :showCancelButton="false"
              >
                <template #empty>
                  <div class="drag-drop-files">
                    <p>Arraste a imagem da família ou clique para selecionar</p>
                  </div>
                </template>
              </FileUpload>
            </div>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-sm p-button-success"
          @click="save()"
        />
        <Button
          :label="'Cancelar'"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="hideForm()"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import "vue-loading-overlay/dist/vue-loading.css";
import sparsService from "../../services/spars.service";
import { FilterMatchMode } from "primevue/api";
import AuthenticatedImage from "../../components/elements/AuthenticatedImage.vue";
import DebouncedFilterInput from "@/components/elements/DebouncedFilterInput.vue";

export default {
  name: "SparsEquipamentFamilies",
  components: {
    AuthenticatedImage,
    DebouncedFilterInput,
  },
  data() {
    return {
      loading: false,
      list: [],
      totalRecords: 0,
      perPage: 25,
      currentPage: 1,
      form: {
        show: false,
        id: null,
        name: null,
        active: null,
        origin: null,
        phc_family_ref: null,
        sales_margin: null,
        weight: null,
        is_default: null,
        images: [],
      },
      filters: {
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        active: { value: null, matchMode: FilterMatchMode.EQUALS },
        origin: { value: null, matchMode: FilterMatchMode.EQUALS },
        phc_family_ref: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sales_margin: { value: null, matchMode: FilterMatchMode.EQUALS },
        weight: { value: null, matchMode: FilterMatchMode.EQUALS },
        is_default: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
      loadRequestId: 0,
      destroyed: false,
    };
  },
  async created() {
    await this.loadProductFamilies();
  },
  deactivated() {
    this.hideForm();
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    this.destroyed = true;
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    async loadProductFamilies(event = {}) {
      const requestId = ++this.loadRequestId;
      this.loading = true;

      try {
        const page = event.page ? event.page + 1 : 1;
        const perPage = event.rows ? event.rows : this.perPage;

        const params = {
          page,
          per_page: perPage,
        };

        if (event.sortField) {
          params.sort_field = event.sortField;
          params.sort_order = event.sortOrder === 1 ? 'asc' : 'desc';
        }

        for (let key in this.filters) {
          const filterValue = this.filters[key].value;
          if (filterValue !== null && filterValue !== '') {
            params[key] = filterValue;
          }
        }

        const response = await sparsService.getProductFamilies(params);
        if (requestId !== this.loadRequestId || this.destroyed) {
          return;
        }

        this.list = response.data || [];
        this.totalRecords = response.total || 0;
        this.currentPage = response.current_page || 1;
        this.perPage = response.per_page || 25;
      } catch (error) {
        if (requestId !== this.loadRequestId || this.destroyed) {
          return;
        }
        console.error(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar dados',
          life: 3000,
        });
      } finally {
        if (requestId === this.loadRequestId && !this.destroyed) {
          this.loading = false;
        }
      }
    },
    hideForm() {
      this.$validator.pause();
      this.$validator.reset();
      return (this.form = {
        show: false,
        id: null,
        name: null,
        active: true,
        origin: null,
        phc_family_ref: null,
        sales_margin: null,
        weight: null,
        is_default: false,
        images: [],
      });
    },
    addNew() {
      return (this.form = {
        show: true,
        id: null,
        name: null,
        active: true,
        origin: null,
        phc_family_ref: null,
        sales_margin: null,
        weight: null,
        is_default: false,
        images: [],
      });
    },
    edit(data) {
      return (this.form = {
        show: true,
        id: data.id,
        name: data.name,
        active: data.active == 1 ? true : false,
        origin: data.origin,
        phc_family_ref: data.phc_family_ref,
        sales_margin: data.sales_margin !== null && data.sales_margin !== undefined ? Number(data.sales_margin) : null,
        weight: data.weight !== null && data.weight !== undefined ? Number(data.weight) : null,
        is_default: data.is_default == 1 ? true : false,
        images: data.images || [],
        data: data,
      });
    },
    save() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }
        this.loading = true;
        if (this.form.id) {
          return this.saveEdit();
        }
        return this.saveNew();
      });
    },
    getFormParams() {
      const params = {
        name: this.form.name,
        active: this.form.active ? 1 : 0,
        origin: this.form.origin,
        phc_family_ref: this.form.phc_family_ref,
        sales_margin: this.form.sales_margin !== null && this.form.sales_margin !== '' ? Number(this.form.sales_margin) : null,
        weight: this.form.weight !== null && this.form.weight !== '' ? Number(this.form.weight) : null,
        is_default: this.form.is_default ? 1 : 0,
      };

      const familyImageRef = this.$refs.familyImage;
      const hasFile = familyImageRef && familyImageRef.files && familyImageRef.files.length > 0;
      if (!hasFile) {
        return params;
      }

      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
      formData.append("image", familyImageRef.files[0]);
      return formData;
    },
    saveNew() {
      this.loading = true;

      return sparsService
        .newProductFamily(this.getFormParams())
        .then(async (response) => {
          this.loading = false;
          if (!response) {
            const errorDetail =
              (sparsService.lastError && (sparsService.lastError.message || (sparsService.lastError.errors && sparsService.lastError.errors.name && sparsService.lastError.errors.name[0]))) ||
              "Erro ao adicionar Família de Produtos";
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: errorDetail,
              life: 4000,
            });
          }
          await this.loadProductFamilies({ page: this.currentPage - 1, rows: this.perPage });
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Família de Produtos adicionada com sucesso",
            life: 3000,
          });
          return this.hideForm();
        });
    },
    saveEdit() {
      this.loading = true;
      return sparsService
        .updateProductFamilies(this.form.id, this.getFormParams())
        .then(async (response) => {
          this.loading = false;
          if (!response) {
            const errorDetail =
              (sparsService.lastError && (sparsService.lastError.message || (sparsService.lastError.errors && sparsService.lastError.errors.name && sparsService.lastError.errors.name[0]))) ||
              "Erro ao atualizar Família de Produtos";
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: errorDetail,
              life: 4000,
            });
          }
          await this.loadProductFamilies({ page: this.currentPage - 1, rows: this.perPage });
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Família de Produtos atualizada com sucesso",
            life: 3000,
          });
          return this.hideForm();
        });
    },
    removeFamilyImage() {
      this.$confirm.require({
        header: "Remover Imagem",
        message: "Tem a certeza que pretende remover a imagem desta família?",
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          this.loading = true;
          return sparsService
            .removeProductFamilyImage(this.form.id)
            .then(async (response) => {
              if (!response) {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: "Ocorreu um erro ao remover a imagem.",
                  life: 3000,
                });
                return;
              }
              this.form.images = [];
              await this.loadProductFamilies({ page: this.currentPage - 1, rows: this.perPage });
              this.$toast.add({
                severity: "success",
                summary: "Sucesso",
                detail: "Imagem removida com sucesso",
                life: 3000,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        },
      });
    },
  },
};
</script>
